import { useMutation } from '@tanstack/react-query';
import { ContentService } from '../../services';
export function useCreateContentMutation() {
    return useMutation({
        mutationFn: (payload) => {
            return ContentService.createContent(payload);
        }
    });
}
